import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Toolbar, CssBaseline, useTheme } from '@mui/material';
import BarSesion from './bar/BarSesion';
import { useStateValue } from '../../contexto/store';

const drawerWidth = 260; 
const miniDrawerWidth = 70;

const AppNavbar = () => {
  const theme = useTheme();
  const [{ sesionUsuario, drawer: drawerState }] = useStateValue();
  const isCollapsed = drawerState?.isCollapsed || false;

  if (!sesionUsuario || !sesionUsuario.autenticado) {
    return <Outlet />;
  }

  const currentDrawerWidth = isCollapsed ? miniDrawerWidth : drawerWidth;

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <BarSesion />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 1, sm: 2, md: 3 }, 
          width: { sm: `calc(100% - ${currentDrawerWidth}px)` },
          bgcolor: 'background.default', 
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          mt: 0,
          transition: theme.transitions.create(['width', 'margin', 'padding'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }}
      >
        <Toolbar sx={{ minHeight: '80px !important' }} /> 
        <Outlet />
      </Box>
    </Box>
  );
};

export default AppNavbar;
